import { gql } from "@apollo/client"

export const GET_TOBE_PAID_NOT_CREATE_YET_INVOICE = gql`
query GetToBePaidNotCreateYetWithPagination($page: Int, $limit: Int, $keyword: String, $academicYearId: ID, $fromDate: String, $toDate: String, $typeOfPayment: String) {
  getToBePaidNotCreateYetWithPagination(page: $page, limit: $limit, keyword: $keyword, academicYearId: $academicYearId, fromDate: $fromDate, toDate: $toDate, typeOfPayment: $typeOfPayment) {
    data {
      isCreated
      student_id
      studentId
      invoiceId
      invoice_id
      currentEnrollmentId
      incomeHeadId
      incomeHeadName
      expiredDate
      paidDate
      studentName
      gender
      foreignProgrammeClass
      khmerProgrammeClass
      generalProgrameClass
      typeOfPayment
      countMonth
      paidAmount
      phoneNumberMother
      phoneNumberFather
      other
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`

// export const IS_ALREADY_CREATE_AND_PUSH_NOTIFICATION_INVOICE = gql`
// query IsAlreadyCreateAndPushNotification($input: IsAlreadyCreateAndPushNotification) {
//   isAlreadyCreateAndPushNotification(input: $input) {
//     notificationId
//     notificationType
//     title
//     body
//     notifyAboutStudent {
//       _id
//       profileImg
//       firstName
//       lastName
//       englishName
//       familyEnglishName
//       studentEnglishName
//       gender
//       dob
//     }
//     notifiedBy {
//       user_id
//       imageSrc
//       email
//       firstName
//       lastName
//       latinName
//       gender
//     }
//     navigetId
//     receiverId
//     isAlreadyView
//     createdAt
//   }
// }
// `

export const GET_TOBE_PAID_NOTIFICATION_PAGINATION = gql`
query GetToBePaidNotificationWithPagination(
  $page: Int
  $limit: Int
  $keyword: String
  $academicYearId: ID
  $fromDate: String
  $toDate: String
  $typeOfPayment: String
) {
  getToBePaidNotificationWithPagination(
    page: $page
    limit: $limit
    keyword: $keyword
    academicYearId: $academicYearId
    fromDate: $fromDate
    toDate: $toDate
    typeOfPayment: $typeOfPayment
  ) {
    data {
      _id
      isSeen
      dateToBePaid
      studentId
      englishName
      firstName
      lastName
      gradeName
      className
      incomeType
      incomeHeadName
      estimateAmount
      isShowMobileApp
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`

export const GET_TOBE_PAID_SENT_HISTORY = gql`
  query GetToBePaidSentHistory($input: ToBePaidNotificationInput) {
  getToBePaidSentHistory(input: $input) {
    notificationType
    title
    body
    notifiedBy {
      _id
      lastName
      latinName
      role
      imageSrc
      gender
      firstName
    }
    createdAt
  }
}
`

export const UPDATE_TOPAY_NOTIFICATION_STATUS = gql`
mutation UpdateToPayNotificationStatus($id: ID!, $isShowMobileApp: Boolean) {
  updateToPayNotificationStatus(_id: $id, isShowMobileApp: $isShowMobileApp) {
    status
    message
  }
}
`

export const DELETE_TOPAY_NOTIFICATION = gql`
mutation DeleteToPayNotification($id: ID!) {
  deleteToPayNotification(_id: $id) {
    status
    message
  }
}
`

export const CREATE_TOBE_PAID_NOTIFICATION = gql`
mutation CreateToBePaidNotification($input: ToBePaidNotificationInput) {
  createToBePaidNotification(input: $input) {
    status
    message
  }
}
`

export const RESEND_TOPAY_NOTIFICATION = gql`
mutation ResendToPayInvoiceNotification($id: ID) {
  resendToPayInvoiceNotification(_id: $id) {
    status
    message
  }
}
`